import { create } from 'zustand';
const useLoadedStore = create((set) => ({
    isBooking: false,
    setIsBooking: (value) => set({ isBooking: value })
}));

export default useLoadedStore;